module.exports = __webpack_public_path__ + "img/primary_4x4.17bc6fe7.svg";